const cdn = "https://writelikelivestorage.blob.core.windows.net/writelikelivestorage-container/";
const avatarCount = 253;

export interface RandomCharacter {
    file: string;
    id: number;
}

export const getCharacter = (id: number) => `${cdn}avatar-${id}.svg`;

export class AssetManager {
    private static instance: AssetManager;

    public static get characters() {
        const c: Array<string> = [];

        for (let i = 0; i < avatarCount; i++) {
            const character = getCharacter(i);
            c.push(character);
        }

        return c;
    }

    public static getInstance(): AssetManager {
        if (!AssetManager.instance) {
            AssetManager.instance = new AssetManager();
        }

        return AssetManager.instance;
    }
}

function shuffleWithSeed(array: Array<unknown>, seed: number) {
    let s = seed;

    function randomWithSeed() {
        const x = Math.sin(s++) * 10000;
        return x - Math.floor(x);
    }

    let m = array.length;
    let t;
    let i;

    while (m) {
        i = Math.floor(randomWithSeed() * m--);
        t = array[m];
        array[m] = array[i];
        array[i] = t;
        ++s;
    }

    return array;
}

export const getCharactersForPlayer = (playerId?: number) => {
    const maxCount = 24;
    const arr: Array<{ id: number; name: string }> = [];

    if (playerId) {
        let i = 0;

        for (const c of AssetManager.characters) {
            arr.push({ id: i, name: c });
            i++;
        }

        shuffleWithSeed(arr, playerId);
    }

    return arr.slice(0, maxCount);
};
